import { MessageCircle, LogIn } from "lucide-react";
import { waLink, CENTRAL_URL } from "@/lib/site";

export default function WhatsAppFloat() {
  return (
    <div className="fixed bottom-5 right-5 z-40 flex items-center gap-3">
      <a
        data-testid="float-central"
        href={CENTRAL_URL}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Abrir a Central do Assinante"
        className="flex items-center gap-2 rounded-full border border-violet-500/40 bg-panel/90 px-4 py-4 text-violet-300 backdrop-blur-md transition-colors duration-200 hover:border-violet-500 hover:text-white sm:px-5"
      >
        <LogIn className="h-5 w-5 shrink-0" />
        <span className="hidden text-sm font-medium sm:block">
          Central do Assinante
        </span>
      </a>
      <a
        data-testid="float-whatsapp"
        href={waLink("Olá! Quero assinar um plano da HPNET.")}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Falar com a HPNET no WhatsApp"
        className="flex items-center gap-2.5 rounded-full bg-violet-600 px-5 py-4 text-white shadow-[0_0_40px_rgba(124,58,237,0.55)] transition-colors duration-200 hover:bg-violet-500"
      >
        <MessageCircle className="h-5 w-5" />
        <span className="hidden text-sm font-medium sm:block">
          Fale com a gente
        </span>
      </a>
    </div>
  );
}
